/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
    GET_ORG_POINTS = '[Org] Get Organization Points',
    GET_ORG_POINTS_SUCCESS = '[Org] Get Organization Points Success',
    GET_ORG_POINTS_FAILED = '[Org] Get Organization Points Failed',
    GET_USER_PASSES = '[Org] Get User Passes',
    GET_USER_PASSES_SUCCESS = '[Org] Get User Passes Success',
    GET_USER_PASSES_FAILED = '[Org] Get User Passes Failed',
    SET_USER_PASSES_LOADER = '[Org] Set User Passes Loader',
    GET_ORGANIZATION = '[Organization] Get Organization',
    GET_ORGANIZATION_SUCCESS = '[Organization] Get Organization Success',
    GET_USER_ORGANIZATION = '[Organization] Get User Organization',
    GET_USER_ORGANIZATION_SUCCESS = '[Organization] Get User Organization Success',
    GET_USER_ORGANIZATION_POINTS = '[Organization] Get User Organization Points',
    GET_USER_ORGANIZATION_POINTS_SUCCESS = '[Organization] Get User Organization Points Success',
    GET_USER_ORGANIZATION_POINTS_FAILED = '[Organization] Get User Organization Points Failed',
    SET_USER_ORGANIZATION_LOADER = '[Org] Set User Organization Loader',
    JOIN_ORGANIZATION = '[Organization] Join Organization',
    JOIN_ORGANIZATION_SUCCESS = '[Organization] Join Organization Success',
    JOIN_ORGANIZATION_FAILED = '[Organization] Join Organization Failed',
    SET_ACTIVE_ORGANIZATION = '[Organization] Set Active Organization',
    SET_ACTIVE_ORGANIZATION_SUCCESS = '[Organization] Set Active Organization',
    LEAVE_ORGANIZATION = '[Organization] Leave Organization',
    LEAVE_ORGANIZATION_SUCCESS = '[Organization] Leave Organization Success',
    LEAVE_ORGANIZATION_FAILED = '[Organization] Leave Organization Failed',
    CLEAR_RECENT_JOINED_ORGANIZATION = '[Organization] Clear Recent Joined Organization',
    GET_ORGANIZATION_CONTENT = '[Organization] Get Organization Content',
    GET_ORGANIZATION_CONTENT_SUCCESS = '[Organization] Get Organization Content Success',
    GET_BROADCAST_MESSAGE = '[Organization] Get Broadcast Message',
    GET_BROADCAST_MESSAGE_SUCCESS = '[Organization] Get Broadcast Message Success',
    SCAN_STATIC_QR = '[Organization] Scan Static Qr',
    SCAN_STATIC_QR_SUCCESS = '[Organization] Scan Static Qr Success',
    GET_USER_FEEDBACK = '[Organization] Get User Feedback',
    GET_USER_FEEDBACK_SUCCESS = '[Organization] Get User Feedback Success',
    USER_FEEDBACK = '[Organization] User Feedback',
    USER_FEEDBACK_SUCCESS = '[Organization] User Feedback Success',
    GET_ACTIVE_SENDEE = "[Organization] Get Active Sendee",
    SET_ACTIVE_SENDEE = "[Organization] Set Active Sendee",
    GET_APPOINTMENT_LOCATION = '[Organization] Get Appointment Location',
    GET_APPOINTMENT_LOCATION_SUCCESS = '[Organization] Get Appointment Location Success',
    CREATE_APPOINTMENT = '[Organization] Create Appointment',
    CREATE_APPOINTMENT_SUCCESS = '[Organization] Create Appointment Success',
}

export const getOrgPoints = createAction(
    ActionTypes.GET_ORG_POINTS
);

export const getOrgPointsSuccess = createAction(
    ActionTypes.GET_ORG_POINTS_SUCCESS,
    props<{ data: any }>()
);

export const getOrgPointsFailed = createAction(
    ActionTypes.GET_ORG_POINTS_FAILED,
    props<{ data: any }>()
);

export const setOrgPointsLoader = createAction(
    ActionTypes.SET_USER_ORGANIZATION_LOADER,
    props<{ status: any }>()
);

export const getUserPasses = createAction(
    ActionTypes.GET_USER_PASSES
);

export const getUserPassesSuccess = createAction(
    ActionTypes.GET_USER_PASSES_SUCCESS,
    props<{ data: any }>()
);

export const getUserPassesFailed = createAction(
    ActionTypes.GET_USER_PASSES_FAILED,
    props<{ data: any }>()
);

export const setUserPassesLoader = createAction(
  ActionTypes.SET_USER_PASSES_LOADER,
  props<{ status: any }>()
);

export const getOrganization = createAction(
  ActionTypes.GET_ORGANIZATION
);

export const getOrganizationSuccess = createAction(
  ActionTypes.GET_ORGANIZATION_SUCCESS,
  props<{ data: any }>()
);

export const getUserOrganization = createAction(
  ActionTypes.GET_USER_ORGANIZATION
);

export const getUserOrganizationSuccess = createAction(
  ActionTypes.GET_USER_ORGANIZATION_SUCCESS,
  props<{ data: any }>()
);

export const getUserOrganizationPoints = createAction(
  ActionTypes.GET_USER_ORGANIZATION_POINTS
);

export const getUserOrganizationPointsSuccess = createAction(
  ActionTypes.GET_USER_ORGANIZATION_POINTS_SUCCESS,
  props<{ data: any }>()
);

export const getUserOrganizationPointsFailed = createAction(
  ActionTypes.GET_USER_ORGANIZATION_POINTS_FAILED,
  props<{ data: any }>()
);

export const joinOrganization = createAction(
  ActionTypes.JOIN_ORGANIZATION,
  props<{ data: any, org: any }>()
);

export const joinOrganizationSuccess = createAction(
  ActionTypes.JOIN_ORGANIZATION_SUCCESS,
  props<{ data: any, org: any }>()
);

export const joinOrganizationFailed = createAction(
  ActionTypes.JOIN_ORGANIZATION_FAILED,
  props<{ data: any }>()
);

export const setActiveORganization = createAction(
  ActionTypes.SET_ACTIVE_ORGANIZATION,
  props<{ data: any, organization: any }>()
);

export const setActiveORganizationSuccess = createAction(
  ActionTypes.SET_ACTIVE_ORGANIZATION_SUCCESS,
  props<{ data: any }>()
);

export const leaveOrganization = createAction(
  ActionTypes.LEAVE_ORGANIZATION,
  props<{ data: any, org: any}>()
);

export const leaveOrganizationSuccess = createAction(
  ActionTypes.LEAVE_ORGANIZATION_SUCCESS,
  props<{ data: any, org : any}>()
);

export const leaveOrganizationFailed = createAction(
  ActionTypes.LEAVE_ORGANIZATION_FAILED,
  props<{ data: any }>()
);

export const clearRecentJoinedOrganization = createAction(
  ActionTypes.CLEAR_RECENT_JOINED_ORGANIZATION
);

export const getOrganizationContent = createAction(
  ActionTypes.GET_ORGANIZATION_CONTENT
);

export const getOrganizationContentSuccess = createAction(
  ActionTypes.GET_ORGANIZATION_CONTENT_SUCCESS,
  props<{ data: any }>()
);

export const getBroadcastMessage = createAction(
  ActionTypes.GET_BROADCAST_MESSAGE
);

export const getBroadcastMessageSuccess = createAction(
  ActionTypes.GET_BROADCAST_MESSAGE_SUCCESS,
  props<{ data: any }>()
);

export const scanStaticQr = createAction(
  ActionTypes.SCAN_STATIC_QR,
  props<{ data: any}>()
);

export const scanStaticQrSuccess = createAction(
  ActionTypes.SCAN_STATIC_QR_SUCCESS,
  props<{ data: any}>()
);

export const getUserFeedback = createAction(
  ActionTypes.GET_USER_FEEDBACK
);

export const getUserFeedbackSuccess = createAction(
  ActionTypes.GET_USER_FEEDBACK_SUCCESS,
  props<{ data: any }>()
);

export const userFeedback = createAction(
  ActionTypes.USER_FEEDBACK,
  props<{ data: any}>()
);

export const userFeedbackSuccess = createAction(
  ActionTypes.USER_FEEDBACK_SUCCESS,
  props<{ data: any}>()
);

export const getActiveSendee = createAction(
  ActionTypes.GET_ACTIVE_SENDEE
);

export const setActiveSendee = createAction(
  ActionTypes.SET_ACTIVE_SENDEE,
  props<{ data: any}>()
);

export const getAppointmentLocation = createAction(
  ActionTypes.GET_APPOINTMENT_LOCATION
);

export const getAppointmentLocationSuccess = createAction(
  ActionTypes.GET_APPOINTMENT_LOCATION_SUCCESS,
  props<{ data: any }>()
);

export const createAppointment = createAction(
  ActionTypes.CREATE_APPOINTMENT,
  props<{ data: any}>()
);

export const createAppointmentSuccess = createAction(
  ActionTypes.CREATE_APPOINTMENT_SUCCESS,
  props<{ data: any}>()
);